import { u as userCardSchema } from "../../../../chunks/validation.js";
import { d as db, u as userCard } from "../../../../chunks/index3.js";
import { f as fakeCards } from "../../../../chunks/fakeCards.js";
import { r as requireUserMiddleware, v as validateBodyMiddleware } from "../../../../chunks/middleware.js";
const load = async (event) => {
  requireUserMiddleware(event);
  let template = {};
  const templateId = event.url.searchParams.get("template");
  if (templateId) {
    const match = fakeCards.find((card) => {
      return card.id === templateId;
    });
    template = match;
  }
  return {
    template
  };
};
const actions = {
  async default(event) {
    const user = requireUserMiddleware(event);
    const body = await validateBodyMiddleware(userCardSchema, event);
    const [card] = await db.insert(userCard).values({
      nickname: body.nickname,
      openedAt: body.openedAt,
      bonusAmount: body.bonusAmount,
      bonusType: body.bonusType,
      bonusSpend: body.bonusSpend,
      bonusDeadline: body.bonusDeadline,
      annualFee: body.annualFee,
      userId: user.id
    }).returning();
    return card;
  }
};
export {
  actions,
  load
};
